import { useAuth } from "../context/AuthContext";
import { useState } from "react";


export const isAdminRole = (role) => role === "ADMIN" || role === "SUPERADMIN";

export const isSuperAdminRole = (role) => role === "SUPERADMIN";

const UserRole = async () => {
  const { authAxios } = useAuth();
  const [role, setRole] = useState(null);
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
      params: {},
    };

    const response = await authAxios().get(
      "/api/backoffice/users/current_user",
      config,
    );

    setRole(response?.data?.role);
  } catch (error) {
    console.log("Error catch");
    console.log(error);
  }

  return role;
};

export function hasNursePermissions() {
  UserRole()
    .then((role) => {
      return (
        role === "USER" ||
        role === "STAFF" ||
        role === "ADMIN" ||
        role === "SUPERADMIN"
      );
    })
    .catch((e) => {
      return false;
    });
  return false;
}

export function HasStaffPermissions() {
  UserRole()
    .then((role) => {
      return role === "STAFF" || role === "ADMIN" || role === "SUPERADMIN";
    })
    .catch((e) => {
      return false;
    });
  return false;
}

export function HasAdminPermissions() {
  UserRole()
    .then((role) => {
      return role === "ADMIN" || role === "SUPERADMIN";
    })
    .catch((e) => {
      return false;
    });
  return false;
}

export function HasDevPermissions() {
  UserRole()
    .then((role) => {
      return role === "SUPERADMIN";
    })
    .catch((e) => {
      return false;
    });
  return false;
}
